import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * FoundingPioneerBadge — early-adopter promotional badge.
 *
 * Shows original price crossed out with the NextXus Prompts Skills rate.  When
 * originalUsd === pioneerUsd (or the caller doesn't supply an original)
 * we simply announce the pioneer status without a price strikethrough.
 */
export default function FoundingPioneerBadge({
  originalUsd,
  pioneerUsd,
  compact = false,
}) {
  const hasDiscount =
    typeof originalUsd === 'number' &&
    typeof pioneerUsd === 'number' &&
    originalUsd > pioneerUsd;

  return (
    <div
      data-testid="founding-pioneer-badge"
      className={
        'inline-flex items-center gap-2 rounded-full border border-amber-300/60 bg-gradient-to-r from-amber-500/15 via-yellow-500/10 to-amber-500/15 text-amber-100 ' +
        (compact ? 'px-2.5 py-1 text-[10px]' : 'px-3 py-1.5 text-xs')
      }
      title="NextXus Prompts Skills rate — token-based curriculum"
    >
      <Sparkles
        className={compact ? 'w-3 h-3 text-amber-300' : 'w-3.5 h-3.5 text-amber-300'}
      />
      <span className="font-mono uppercase tracking-[0.16em] font-bold">
        NextXus Prompts Skills
      </span>
      {hasDiscount && (
        <span className="flex items-center gap-1 pl-1 border-l border-amber-300/40 ml-1">
          <span className="line-through text-amber-200/60">${originalUsd}</span>
          <span className="text-white font-bold">${pioneerUsd}</span>
        </span>
      )}
    </div>
  );
}
